import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-non-sellable-dialog',
  templateUrl: './non-sellable-dialog.html',
  styleUrls: ['./non-sellable-dialog.scss'],
})
export class NonSellableDialogComponent implements OnInit {
  nonSellableProducts: any[]

  nonSellableArr: any[]

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.nonSellableProducts = data.nonSellableProducts
    })
    this.nonSellableArr = this.nonSellableProducts.filter(
      (n, i) => this.nonSellableProducts.indexOf(n) === i
    )
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.NON_SELLABLE,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
